import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromNode from './reducers/node.reducer';
import { EffectsModule } from '@ngrx/effects';
import { NodeEffects } from './effects/node.effects';
import * as fromNodeFilter from './reducers/node-filter.reducer';
import { NodeFilterEffects } from './effects/node-filter.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('node', fromNode.reducer),
    EffectsModule.forFeature([NodeEffects, NodeFilterEffects]),
    StoreModule.forFeature('nodeFilter', fromNodeFilter.reducer)
  ]
})
export class NodeModule { }
